import { create } from "zustand";

export const useLoaderStore = create((set) => ({
    isLoading: false,
    message: '',
    progress: 0,
    pcarrow: false,
    mobilearrow: false,
    showLoader: (msg = 'Saqlanmoqda...', progress = 0) => {
      set({ isLoading: true, message: msg, progress })
     
    },
    hideLoader: () => {
      set({ isLoading: false, message: '', progress: 0 })
      set({ pcarrow: true, mobilearrow: true })
      setTimeout(() => {
        set({ pcarrow: false, mobilearrow: false })
      }, 3000);
    },
    updateProgress: (progress) => {
      set((state) => ({ ...state, progress }))
    }
  }));